// extracted by mini-css-extract-plugin
module.exports = {"header":"sectionHeaderLarge_header__1WYzr"};